import { Box, Divider, Grid2 as Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";

export const DosingInformationSection = () => {
  const dosingInstructions = [
    {
      icon: "/images/taking-ibtrozi/convo-icon-desktop-2.svg",
      iconAlt: "",
      content: <><strong>Take 3 IBTROZI pills<br />once a day</strong></>,
    },
    {
      icon: "/images/taking-ibtrozi/clock-icon-desktop.svg",
      iconAlt: "",
      content: (
        <>
          <strong>Take IBTROZI</strong> at about the same time each day
        </>
      ),
    },
    {
      icon: "/images/taking-ibtrozi/do-not-eat-icon-desktop.svg",
      iconAlt: "",
      content: (
        <>
          <strong>Take on an empty stomach</strong>
          <br />
          (2 hours before or 2 hours after eating)
        </>
      ),
    },
    {
      icon: "/images/taking-ibtrozi/drink-icon-desktop.svg",
      iconAlt: "",
      content: (
        <>
          <strong>Take with water</strong>
          <br />
          (swallow pills whole)
		  <br /> 
		Do not open, crush, chew or dissolve the capsule before swallowing
        </>
      ),
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "90%",
        minHeight: "500px",
        padding: "15px 37px 20px",
        borderRadius: "20px",
        border: "1.5px solid",
        borderColor: "primary.main",
        boxShadow: "-8px 8px 0px #b7b9d0",
        bgcolor: "background.paper",
        margin: "32px auto"
      }}
    >
      <Grid container spacing={4} justifyContent="center" alignItems="center">
        {dosingInstructions.map((instruction, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6 }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems="center"
              sx={{ py: 1.5 }}
            >
              <Box
                component="img"
                src={instruction.icon}
                alt={instruction.iconAlt}
                sx={{ width: 115, height: 115 }}
              />
              <Box sx={{ width: "205px" }}>
                <Typography
                  variant="body1"
                  color="primary.main"
                  textAlign={{ xs: "center", sm: "left" }}
                  mb="0"
                >
                  {instruction.content}
                </Typography>
              </Box>
            </Stack>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Divider sx={{ borderColor: "primary.main" }} />
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={3}
          sx={{ mt: 3.8 }}
        >
          {/* Left label */}
          <Grid
            sx={{
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Stack 
              direction="row" 
              spacing={3} 
              alignItems="center" 
              sx={{ justifyContent: { xs: "center", sm: "inherit" } }}
            >
              <Typography
                variant="body1"
                color="primary.main"
                fontWeight={900}
                textAlign="center"
              >
                May be taken:
              </Typography>
            </Stack>
          </Grid>

          {/* House icon with label */}
          <Grid>
            <Stack direction={{ xs: "column-reverse", sm: "row" }} spacing={3} alignItems="center">
              <Typography variant="body1" fontWeight={900} color="primary.main">
                at home
              </Typography>
              <Box
                component="img"
                src="/images/taking-ibtrozi/house-heart-icon-desktop.svg"
                alt=""
                sx={{ width: 81, height: 72 }}
              />
            </Stack>
          </Grid>

          {/* OR */}
          <Grid>
            <Typography variant="h6" fontWeight={900} color="primary.main">
              OR
            </Typography>
          </Grid>

          {/* Triangle icon with label */}
          <Grid>
            <Stack direction={{ xs: "column-reverse", sm: "row" }} spacing={3} alignItems="center">
              <Typography variant="body1" fontWeight={900} color="primary.main">
                on the go
              </Typography>
              <Box
                component="img"
                src="/images/triangle-icon.svg"
                alt=""
                sx={{ width: 71, height: 74 }}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};